import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import icMenuHamburger from "@/assets/icons/ic-menu-hamburger.svg";
import icXClose from "@/assets/icons/ic-x-close.svg";
import LogoMobile from "@/assets/images/mobile-logo.svg";

interface MobileMenuSheetProps {
  children: (opts: { close: () => void }) => React.ReactNode;
}

export const MobileMenuSheet = ({ children }: MobileMenuSheetProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="lg:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" className="w-12 h-12 rounded-full" aria-label="Menu">
            <img src={icMenuHamburger} alt="" width={24} height={24} />
          </Button>
        </SheetTrigger>
        <SheetContent
          side="right"
          className="w-screen max-w-none h-[100dvh] p-0 border-0 shadow-none flex flex-col [&>button:last-child]:hidden"
        >
          <SheetTitle className="sr-only">Navigation menu</SheetTitle>
          <div className="flex items-center justify-between px-5 h-[64px] border-b border-black/5">
            <Link to="/" onClick={() => setOpen(false)}>
              <img src={LogoMobile} alt="PwC AI Agent Marketplace" />
            </Link>
            <Button
              variant="ghost"
              size="icon"
              className="w-12 h-12 rounded-full focus-visible:ring-0 focus-visible:ring-offset-0 focus:outline-none"
              aria-label="Close menu"
              onClick={() => setOpen(false)}
            >
              <img src={icXClose} alt="" width={24} height={24} />
            </Button>
          </div>
          <div className="flex-1 flex flex-col justify-between px-5 py-3 pb-10 rounded-lg backdrop-blur-[200px]">
            {children({ close: () => setOpen(false) })}
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
